import { ExpertsApplyModel } from "../../../domain/ExpertsApplyFormModel";
import { DialogType, EntityDialog } from "../../types";
import { buildDefinitions } from "./buildDefinitions/buildDefinitions";
import { ActivityFeed, refreshActivityFeed } from "@ofqual/portal-activity-feed";
import { RenderDialog } from "./RenderDialog";
import { ActivityType } from "../../../domain/ActivityType";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

type SpecialistActivityFeedProps = {
  specialist: ExpertsApplyModel;
  focusedEntity: EntityDialog | null;
  setFocussedEntity: (value: React.SetStateAction<EntityDialog | null>) => void;
};

export const SpecialistActivityFeed: React.FC<SpecialistActivityFeedProps> = ({
  specialist,
  setFocussedEntity,
  focusedEntity,
}) => {
  const dispatch = useDispatch();
  const definitions = buildDefinitions(
    specialist,
    (activity, dialogType) =>
    (setFocussedEntity({
      dialogType: dialogType || DialogType.ActivityAction,
      focusedActivity: activity,
    })),

  );
  const activityTypesArray: number[] = Object.values(ActivityType)
    .filter(value => typeof value === 'number') as unknown as number[];
  const acceptedActivityTypes = activityTypesArray.filter((type) =>
    type !== ActivityType.SpecialistOfqualSendPublicMessage
    && type !== ActivityType.SpecialistCitizenSendPublicMessage
    && type !== ActivityType.SpecialistPublicMessageRead
    && type !== ActivityType.SpecialistFurtherEvidenceRequested);

  useEffect(() => {
    //Only run after other tab renders 
    dispatch(refreshActivityFeed(specialist.id, { activityTypes: acceptedActivityTypes }));
  }, [dispatch, specialist.id, acceptedActivityTypes]);

  return (
    <>
      <ActivityFeed
        resourceId={specialist.id}
        definitions={definitions}
        params={{ activityTypes: acceptedActivityTypes }}
        actions={[
          {
            label: "Add Note",
            dataTest: "add-note-button",
            action: () =>
              setFocussedEntity({
                dialogType: DialogType.AddCaseNote,
              }),
          },
          {
            label: "Internal Message",
            dataTest: "internal-message-button",
            action: () =>
              setFocussedEntity({
                dialogType: DialogType.AddInternalMessage,
              }),
          }

        ]}
      />
      <RenderDialog
        focusedEntity={focusedEntity}
        onClose={() => setFocussedEntity(null)}
        specialist={specialist}
      />
    </>
  );
};